// extracted by mini-css-extract-plugin
export var label = "_b9-5";
export var slideContainer = "_b9-0";
export var slider = "_b9-1";
export var sliderLg = "_b9-4";
export var sliderMd = "_b9-3";
export var sliderSm = "_b9-2";